import * as actions from "./actionsTypes";

const initialData = {
  loaderCourses: false,
  courses: null,
  coursesFail: null,
  saveLoaderCourses: false,
  coursesFormError: null,
  loaderCoursesEmployees: false,
  coursesEmployees: null,
  coursesEmployeesFail: null,
  loaderEnrollment: false,
  enrollmentSuccess: null,
  enrollmentFail: null,
  loaderRegisteredEmployees: false,
  registeredEmployees: null,
  registeredEmployeesFail: null,
  loaderEnrolledEmployees: false,
  enrolledEmployees: null,
  enrolledEmployeesFail: null,
  loaderApproveEnrollment: false,
  approveEnrollmentSuccess: null,
  approveEnrollmentFail: null,
};

export default function EnrollmentCapacitacionReducer(
  state = initialData,
  action
) {
  switch (action.type) {
    case actions.LOADER_COURSES:
      return { ...state, loaderCourses: action.payload };

    case actions.GET_COURSES:
      return { ...state, courses: action.payload };

    case actions.COURSES_FAIL:
      return { ...state, coursesFail: action.payload };

    case actions.SAVE_LOADER_COURSES:
      return { ...state, saveLoaderCourses: action.payload };

    case actions.FORM_COURSES_FAIL:
      return { ...state, coursesFormError: action.payload };

    case actions.LOADER_COURSES_EMPLOYEES:
      return { ...state, loaderCoursesEmployees: action.payload };

    case actions.GET_COURSES_EMPLOYEES:
      return { ...state, coursesEmployees: action.payload };

    case actions.COURSES_EMPLOYEES_FAIL:
      return { ...state, coursesEmployeesFail: action.payload };

    case actions.LOADER_ENROLLMENT:
      return { ...state, loaderEnrollment: action.payload };

    case actions.ENROLLMENT_SUCCESS:
      return { ...state, enrollmentSuccess: action.payload };

    case actions.ENROLLMENT_FAIL:
      return { ...state, enrollmentFail: action.payload };

    case actions.LOADER_REGISTERED_EMPLOYEES:
      return { ...state, loaderRegisteredEmployees: action.payload };

    case actions.GET_REGISTERED_EMPLOYEES:
      return { ...state, registeredEmployees: action.payload };

    case actions.REGISTERED_EMPLOYEES_FAIL:
      return { ...state, registeredEmployeesFail: action.payload };

    case actions.LOADER_ENROLLED_EMPLOYEES:
      return { ...state, loaderEnrolledEmployees: action.payload };

    case actions.GET_ENROLLED_EMPLOYEES:
      return { ...state, enrolledEmployees: action.payload };

    case actions.ENROLLED_EMPLOYEES_FAIL:
      return { ...state, enrolledEmployeesFail: action.payload };

      case actions.LOADER_APPROVE_ENROLLMENT:
        return { ...state, loaderApproveEnrollment: action.payload };
  
      case actions.APPROVE_ENROLLMENT_SUCCESS:
        return { 
          ...state, 
          approveEnrollmentSuccess: action.payload,
          approveEnrollmentFail: null 
        };
  
      case actions.APPROVE_ENROLLMENT_FAIL:
        return { 
          ...state, 
          approveEnrollmentFail: action.payload,
          approveEnrollmentSuccess: null 
        };
  
    default:
      return state;
  }
}
